import http from "api/https";

export const getdepartments = (): Promise<any> => {
  return http.get("/Department/GetAll");
};

export const getdepartmentsByOrganization = (organizationId: number): Promise<any> => {
  return http.get(`/Department/GetByOrganizationId?organizationId=${organizationId}`);
};

export const getdepartment = (id: number): Promise<any> => {
  return http.get(`/Department/GetOneById?id=${id}`);
};

export const createdepartment = (data: any): Promise<any> => {
  return http.post("/Department/Create", data);
};

export const updatedepartment = (data: any): Promise<any> => {
  return http.put("/Department/Update", data);
};

export const deletedepartment = (id: number): Promise<any> => {
  return http.remove(`/Department/Delete?id=${id}`, {});
};
